import { render, staticRenderFns } from "./StoreLocator.vue?vue&type=template&id=20ed3e25&scoped=true"
import script from "./StoreLocator.vue?vue&type=script&lang=ts"
export * from "./StoreLocator.vue?vue&type=script&lang=ts"
import style0 from "./StoreLocator.vue?vue&type=style&index=0&id=20ed3e25&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed3e25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ed3e25')) {
      api.createRecord('20ed3e25', component.options)
    } else {
      api.reload('20ed3e25', component.options)
    }
    module.hot.accept("./StoreLocator.vue?vue&type=template&id=20ed3e25&scoped=true", function () {
      api.rerender('20ed3e25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StoreLocator.vue"
export default component.exports